import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { TRADE_BASE_PATH } from '../../../../../../../../../features/trade/trade-routing';

// This route exists just to provide breadcrumbs for the UTC match subpages.
export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/utc/_utc')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'utc-trade-list',
        label: 'Trades',
        to: TRADE_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
